export default "__VITE_ASSET__CjG9ox8v__"